import React, { Fragment, useEffect, useState ,useRef} from "react";
import axios from "axios";
import { baseUrl } from "../Common/Constants";
import { useSelector } from "react-redux";
import { getParamsSelector } from "../Common/Slices/ParamSlice";
import {defaultDate} from "../Common/Constants"
import { cloneDeep, identity,  update } from "lodash";
import { Grid, GridCellProps, GridColumn, GridPageChangeEvent ,GridNoRecords} from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch } from "../Core/store.hooks";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { machineHealthDataToHours, machineTimesToHours, msToHours } from "../Common/Util_methods/format";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { getMdcDataSelector, loadingMdcDataSelector } from "./mdcSlice";
import Format from "../Common/Util_methods/formatParamOptions";
import { getDevicesSelector } from "../Devices/Slice";
import { orderBy } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export"; import {
    Menu,
    MenuItem,
    MenuItemLink,
    MenuSelectEvent,
} from "@progress/kendo-react-layout";

interface MachineHealthProps{
    id:string;
    header:string;
    addSeries:Function;
}

interface InterruptData{
  dailyData: any[];
  deviceCount: number;
  deviceData: any[];
  end: string;
  interruptCount: number;
  interruptsPerRunningHour: number;
  runningDuration: number;
  seriesID: string;
  start: string;
}

interface PageState {
  skip: number;
  take: number;
}

const MdcGridWidget = (props:MachineHealthProps) => {
    // const initialSort: any = [{
    //       field: "average",
    //       dir: "desc",
    //   },];

    const initialSort: any = [
        {
            field: "average",
            dir: "desc",
        },
    ];
    const initialSort2: any = [
        {
            field: "ts",
            dir: "desc",
        },
    ];

    interface PageState {
        skip: number;
        take: number;
    }


    const initialDataState: PageState = { skip: 0, take: 100 };
    const [data, setData] = useState([]);
    const [sort, setSort] = useState(initialSort);
    const [sort2, setSort2] = useState(initialSort2);
    const [filter, setFilter] = useState();
    const [page, setPage] = useState<PageState>(initialDataState);

    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
    };




    const [gridData, updateGridData] = useState<any>();
    const [fetchedSeries, updateFetchedSeries] = useState([])
    const [selectedSeries, updateSelectedSeries] = useState(null);
    const [seriesCount, updateSeriesCount] = useState(null);
    const [dataProcessed, setDataProcessed] = useState(false);

    //const [sort, setSort] = useState(initialSort);


    const mdcData = useSelector(getMdcDataSelector).mdcData;
    const loadingState = useSelector(loadingMdcDataSelector);

    const deviceObjects = useSelector(getDevicesSelector);

    useEffect(()=>{
      if(mdcData != null){
          if (mdcData.length > 0) {
              
              let newFetchedSeries: any = mdcData.map((obj) => {
                  if (obj != null) {
                      return obj.seriesID
                  }
              }
              )
            updateFetchedSeries( newFetchedSeries )
          if (selectedSeries === null){
            if(mdcData.at(0) != null){
              updateGridData(mdcData.at(0))
              updateSelectedSeries(mdcData.at(0).seriesID)
              updateSeriesCount(mdcData.length);
            }
          }else if(mdcData.length === seriesCount){
            const data = mdcData.find((obj)=>obj.seriesID === selectedSeries)
            updateGridData(data)
          }else{
            updateGridData(mdcData.at(-1))
            updateSelectedSeries(mdcData.at(-1).seriesID)
            updateSeriesCount(mdcData.length);
          }
          setPage(initialDataState)
        }
        setDataProcessed(true);
      }
    },[mdcData])

    useEffect(()=>{
      if(selectedSeries != null){
        const data = mdcData.find((obj)=>obj.seriesID === selectedSeries)
        updateGridData(data)
        setDataProcessed(true);
      }
    },[selectedSeries])

    useEffect(()=>{
      if(loadingState === "pending"){
          setDataProcessed(false);
      }
      if(loadingState === "rejected"){
          setDataProcessed(true);
      }
      if(loadingState === "fulfilled" && mdcData.length === 0){
          setDataProcessed(true);
      }
    },[loadingState])

    const _export = useRef<ExcelExport | null>(null);

    const excelExport = (event: MenuSelectEvent) => {
        if (event.item.text === "Export to Excel") {
            if (_export.current !== null) {
                _export.current.save();
            }
        }
    };
    function renderMenuIconIfApplicable(props: any) {
        return props.item.icon ? (
            <span
                style={{ fontSize: "16px" }}
                className={`k-icon k-i-${props.item.icon}`}
                role="presentation"
                key="0"
            />
        ) : null;
    }
    const linkRender = (props: any) => {
        return (
            <MenuItemLink url={props.item.url} opened={props.opened}>
                {[renderMenuIconIfApplicable(props), props.item.text, null]}
            </MenuItemLink>
        );
    };
    const singleDeviceSeries = (selectedSeries:string) =>{
        const series = mdcData.find((obj)=>obj.seriesID === selectedSeries);
        if(series != null){
          const device = series.device;
          const deviceNames = Format.DeviceTypes(deviceObjects,"Device Name");
          const deviceNameSizeVersions = Format.DeviceTypes(deviceObjects,"Device Name + Device Size + Version");
          if(deviceNames.includes(device) || deviceNameSizeVersions.includes(device) || series.deviceCount>1){
              return false;
          }
          
        }
        return true;
    }

   ;

    const seriesHandler = (e:DropDownListChangeEvent) =>{
      setPage(initialDataState)
      updateSelectedSeries(e.target.value)
    }

    const handleGridButton = (deviceWithSerial:string) =>{
        const newSeries:any = {
          deviceName:null,
          deviceNameVersion:null,
          devicesWithSerial:[deviceWithSerial],
          deviceTypes:[],
          header:gridData.header,
          seriesID: deviceWithSerial+" "+gridData.header
        }
        props.addSeries(newSeries)
    }

    const CommandCell = (props:GridCellProps) => {
      return(
        <td> 
          <Button onClick={()=>handleGridButton(props.dataItem.deviceName)}>Add Series</Button>
        </td>
      )
    }
    const renderMetrics = () => {
        if (gridData.rawData.length > 0) {
            return (<>
                  <div style={{ margin: "10px" }}>Header: {gridData.header} </div>

                    <div style={{ margin: "10px" }}>Unit: {gridData.unit} </div>
                    <div style={{ margin: "10px" }}>Range Average: {Number(gridData.average).toFixed(2)} </div>
                    <div style={{ margin: "10px" }}>Range Sum: {gridData.rawSum} </div>
                    <div style={{margin:"10px"}}>Range Min: {gridData.min} </div>
                    <div style={{ margin: "10px" }}>Range Max: {gridData.max} </div>
                    <div style={{ margin: "10px" }}>Initial value: {gridData.initialValue} </div>
                    <div style={{ margin: "10px" }}>All time Sum: {gridData.totalSum} </div>
                    <div style={{ margin: "10px" }}>Total Devices: {gridData.deviceCount} </div></>
                )
        }
    }
    const renderGrid = () => {
        if(!singleDeviceSeries(selectedSeries)){
            return (
                <Fragment>
                    <ExcelExport data={gridData.deviceData} ref={_export}>
                  <Grid
                    data={orderBy(gridData.deviceData,sort)}
                    // pageable={true}
                    // onPageChange={pageChange}
                    // skip={page.skip}
                    // take={page.take}
                    // total={gridData.deviceData.length} 
                        scrollable={"scrollable"}
                        sortable
                        sort={sort}
                        onSortChange={(e) => {
                            setSort(e.sort);
                        }}
                        style={{ maxHeight: "calc( 100% - 50px)", height: "calc( 100% - 50px)" }}

                    >
                    <GridColumn field="customerName" title="Customer" />
                    <GridColumn field="cadid" title="CADID" />
                    <GridColumn field="deviceName" title="Device" />
                    <GridColumn field="average" title ="Average" />
                    <GridColumn cell={CommandCell} />
                  </Grid>
             
        </ExcelExport >   </Fragment>
            )
        }else{
            if (gridData.rawData != null) {
                return (
                    <Fragment>   <ExcelExport data={gridData.rawData} ref={_export}>
                        <Grid 
                              sortable
                            sort={sort2}
                            onSortChange={(e) => {
                                setSort2(e.sort);
                            }}
                            data={orderBy(gridData.rawData, sort2)}
                           // columnVirtualization={true}
                            scrollable={"scrollable"}
                         //  onPageChange={pageChange}
                          //  skip={page.skip}
                          //  take={page.take}
                         //   total={gridData.rawData.length}
                            style={{ maxHeight: "calc( 100% - 50px)", height: "calc( 100% - 50px)" }}
                          
                        >
                            <GridNoRecords>
                                No Data Found For Selected Date Range
                            </GridNoRecords>
                            <GridColumn field="ts" title="Date/Time"/>
                            <GridColumn field="numericValue" title="Value" />
                            <GridColumn field="rangeCumulativeValue" title="Cumulative Value (Range)" />
                            <GridColumn field="cumulativeValue" title="Cumulative Value (All time)" />
                        </Grid>
                    </ExcelExport>
                    </Fragment>
                )
            }
        }
    }


    if (!dataProcessed){
      return <Spinner text="data" />;
    }
    if (mdcData == null) {
      //proper error handling should be added with promise error response
      return (
          <ErrorMessage
              text={"Oops something went wrong, unable to get data."}
              id={props.id}
              header={props.header}
          />
      );
  }   
    if (mdcData != null && mdcData.length == 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if(gridData != null){
        return(
            <div style={{ height: "100%", position: "relative" }}>
            {/* <label>
                Series
            </label> */}
            <div style={{display:"flex", flexDirection:"row"}}>
                <DropDownList 
                popupSettings={{width:"auto"}}
                data={fetchedSeries}
                value={selectedSeries}
                onChange={seriesHandler}
                style={{height:"fit-content"}}
                    />
                    {renderMetrics() }
                </div>
                <div style={{
                    position: "absolute",
                    top: "-20px",
                    left: "-20px"
                }}>
                    <Menu
                        openOnClick={true}
                        onSelect={excelExport}
                        linkRender={linkRender}
                    >
                        <MenuItem
                            text=""
                            icon="more-horizontal"
                            data={{}}
                            cssStyle={{ color: "black" }}
                        >
                            <MenuItem text="Export to Excel" />
                        </MenuItem>
                    </Menu>
                </div>
            {renderGrid()}
        </div>
        )
    }
    return null;
}

export default MdcGridWidget;